import React from 'react';
import {
    StarSvg,
} from "../common/svg"
import PrintsLandingCarousel from './prints-landing-carousel';
import { testimonialData } from '../../data/testimonials';

const TestimonialsCarousel = () => {
    const slides = testimonialData.map((testimonial, index) => {
        return (
            <div
                key={`${testimonial.name}-${index}`}
                className="carousel-cell testimonial-cell"
            >
                <div className="star-bar">
                    {Array.from({length: testimonial.stars}, () => <>{StarSvg}</>)}
                </div>
                <p className="message">
                    {testimonial.message}
                </p>
                <p className="attribution">
                    {testimonial.name}<br />
                    {testimonial.town}, {testimonial.country}
                </p>
            </div>
        );
    });

	return (
        <PrintsLandingCarousel
            slides={slides}
            shuffleSlides={true}
        />
	);
};

export default TestimonialsCarousel;